module.exports = __webpack_public_path__ + "img/halloween_pumpkin.17e016ea.svg";